import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { FormControl } from '@axo/ui-core/components/form/FormControl';
import { Grid, Stack } from '@axo/ui-core/components/layout/item';
import { USPsList } from '@axo/ui-feature/components/USPsList';
import { useFormContext } from 'react-hook-form';
import { radioOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import { AccountFormGroupData } from '../../../FormData.se.types';
import styles from '../../../loan.module.scss';
import {
  accountClearingNumberFieldOptions,
  accountNumberFieldOptions,
} from './config';

export const AccountFormGroup = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const keyBenefits = t('AccountNumber.KeyBenefits', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const askAccountDetails = watch('Frontend/AddAccountNumber') === 'Yes';

  return (
    <>
      <Stack gap="3xs">
        <USPsList title={t('AccountNumber.title')} gap={'3xs'}>
          {keyBenefits?.map((benefit, index) => (
            <USPsList.Item key={index}>
              <p dangerouslySetInnerHTML={{ __html: t(benefit) }} />
            </USPsList.Item>
          ))}
        </USPsList>
      </Stack>

      <div className={styles.inputGroup} data-grey={true}>
        <FormControl className={styles.customLabelControl}>
          <FormControl.Label>
            <span
              dangerouslySetInnerHTML={{ __html: t('AccountNumber.question') }}
            />
          </FormControl.Label>
          <Grid columns={gridColumns}>
            <RadioFieldUI<AccountFormGroupData>
              name="Frontend/AddAccountNumber"
              data-testid="add-account-number-radio"
              radioStyle="both"
              options={radioOptions}
            />
          </Grid>
        </FormControl>

        {askAccountDetails && (
          <Grid columns={gridColumns}>
            <NumberFieldUI<AccountFormGroupData>
              name="LoanApplication/AccountClearingNumber"
              label={t('AccountClearingNumber.label')}
              data-testid="clearing-number-input"
              {...accountClearingNumberFieldOptions}
            />

            <NumberFieldUI<AccountFormGroupData>
              name="LoanApplication/AccountNumber"
              label={t('AccountNumber.label')}
              data-testid="account-number-input"
              {...accountNumberFieldOptions}
            />
          </Grid>
        )}
      </div>
    </>
  );
};
